import {
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import { GetErpTypeFromConfig } from "../../../App";
import SystemSettings from "./SystemSettings";
import TradeContactGrid from "../../../components/TradeContactGrid/TradeContactGrid";

const SystemSettingsTabs = () => {
    const ERP_TYPE = GetErpTypeFromConfig();
    const begin = (args: any) => {
        if (args.isSwiped) {
            args.cancel = true;
        }
    };
    return (
        <div className='main-content-order-request'>
            <TabComponent
                enablePersistence={true}
                selecting={begin.bind(this)}
                statelessTemplates={['directiveTemplates']}
            >
                <TabItemsDirective>
                    <TabItemDirective
                        header={{ text: 'Fetch Size' }}
                        content={() => (
                            <>
                                <SystemSettings />
                            </>
                        )}
                    />
                    <TabItemDirective
                        header={{ text: 'Trade Contact' }}
                        content={() => (
                            <>
                                <TradeContactGrid />
                            </>
                        )}
                    />
                </TabItemsDirective>
            </TabComponent>
        </div>
    );
};

export default SystemSettingsTabs;
